// extracted by mini-css-extract-plugin
module.exports = {"Label":"LogpointOptions_Label__BYQ6G","Options":"LogpointOptions_Options__BlO6l"};